export default __webpack_public_path__ + "static/media/accordion-menu.bfdf6ba9.svg";